export default __webpack_public_path__ + "static/media/ser1.daa49ada.svg";